if (typeof ProductQuantity !== 'function') {

  class BaseQuantity extends HTMLElement {
    constructor() {
      super();
      this._handlersAttached = false;
    }

    setupQuantityHandlers(qty, qtyMinus, qtyPlus) { // Para la lógica del carrito
      if (this._handlersAttached) return;
      this._handlersAttached = true;

      const updateButtons = () => {
        const currentValue = parseInt(qty.value);
        const currentMinOrder = parseInt(qty.getAttribute('data-pedido-minimo')) || 1;
        qtyMinus.classList.toggle('disabled', currentValue <= currentMinOrder);
      };

      const handleMinus = (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        const qtyElement = this.closest('cart-product-quantity').querySelector('.qty');
        const currentValue = parseInt(qtyElement.value);
        const currentMinOrder = parseInt(qtyElement.getAttribute('data-pedido-minimo')) || 1;
        console.log('Carrito - Minus clicked', currentValue, currentMinOrder);
        if (currentValue > currentMinOrder) {
          qtyElement.value = currentValue - currentMinOrder;
          updateButtons();
          // Agregamos información adicional para la actualización del carrito
          const cartItem = this.closest('[data-js-cart-item]');
          this.dispatchEvent(new CustomEvent('quantity-updated', {
            detail: { 
              quantity: qtyElement.value,
              line: cartItem ? cartItem.dataset.line : null 
            },
            bubbles: true
          }));
        }
      };

      const handlePlus = (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        const qtyElement = this.closest('cart-product-quantity').querySelector('.qty');
        const currentValue = parseInt(qtyElement.value);
        const currentMinOrder = parseInt(qtyElement.getAttribute('data-pedido-minimo')) || 1;
        console.log('Carrito - Plus clicked', currentValue, currentMinOrder);
        qtyElement.value = currentValue + currentMinOrder;
        updateButtons();
        // Agregamos información adicional para la actualización del carrito
        const cartItem = this.closest('[data-js-cart-item]');
        this.dispatchEvent(new CustomEvent('quantity-updated', {
          detail: { 
            quantity: qtyElement.value,
            line: cartItem ? cartItem.dataset.line : null 
          },
          bubbles: true
        }));
      };

      qtyMinus.replaceWith(qtyMinus.cloneNode(true));
      qtyPlus.replaceWith(qtyPlus.cloneNode(true));

      const newMinus = this.querySelector('.qty-minus');
      const newPlus = this.querySelector('.qty-plus');

      newMinus.addEventListener('click', handleMinus);
      newPlus.addEventListener('click', handlePlus);

      updateButtons();
    }
  }

  class ProductQuantity extends BaseQuantity {
    connectedCallback() {
      const qty = this.querySelector('.product-quantity__selector');
      if (!qty) return;

      const clone = qty.cloneNode(true);
      qty.replaceWith(clone);

      const minOrder = parseInt(clone.getAttribute('data-pedido-minimo')) || 1;
      clone.value = Math.max(minOrder, parseInt(clone.value) || minOrder);

      this.setupProductQuantityHandlers(
        clone,
        this.querySelector('.product-quantity__minus'),
        this.querySelector('.product-quantity__plus'),
        minOrder // Pasar minOrder aquí
      );
    }

    setupProductQuantityHandlers(qty, qtyMinus, qtyPlus, minOrder) {
      if (this._handlersAttached) return;
      this._handlersAttached = true;

      const updateButtons = () => {
        qtyMinus.classList.toggle('disabled', parseInt(qty.value) <= minOrder);
      };

      this.handleProductMinus = (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        const currentValue = parseInt(qty.value);
        if (currentValue > minOrder) {
          qty.value = currentValue - minOrder;
          updateButtons();
          this.dispatchEvent(new CustomEvent('quantity-updated', {
            detail: { quantity: qty.value },
            bubbles: true
          }));
        }
      };

      this.handleProductPlus = (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        const currentValue = parseInt(qty.value);
        qty.value = currentValue + minOrder;
        updateButtons();
        this.dispatchEvent(new CustomEvent('quantity-updated', {
          detail: { quantity: qty.value },
          bubbles: true
        }));
      };

      qtyMinus.replaceWith(qtyMinus.cloneNode(true));
      qtyPlus.replaceWith(qtyPlus.cloneNode(true));

      const newMinus = this.querySelector('.product-quantity__minus');
      const newPlus = this.querySelector('.product-quantity__plus');

      newMinus.addEventListener('click', this.handleProductMinus);
      newPlus.addEventListener('click', this.handleProductPlus);

      updateButtons();
    }
  }

  class CartProductQuantity extends BaseQuantity {
    connectedCallback() {
      const qty = this.querySelector('.qty');
      if (!qty) return;

      console.log('Carrito - Input:', qty, qty.getAttribute('data-pedido-minimo'));

      const minOrder = parseInt(qty.getAttribute('data-pedido-minimo')) || 1;
      qty.value = Math.max(minOrder, parseInt(qty.value) || minOrder);

      console.log('Carrito - Initial minOrder:', minOrder);

      this.setupQuantityHandlers(
        qty,
        this.querySelector('.qty-minus'),
        this.querySelector('.qty-plus')
      );
    }
  }

  // Registrar componentes
  if (!customElements.get('product-quantity')) {
    customElements.define('product-quantity', ProductQuantity);
  }
  if (!customElements.get('cart-product-quantity')) {
    customElements.define('cart-product-quantity', CartProductQuantity);
  }

  // Modificar el event listener global para no bloquear completamente el evento
  document.addEventListener('quantity-updated', (e) => {
    // Detener la propagación inmediata
    e.stopImmediatePropagation();
    
    // Si el evento contiene información del carrito, intentamos actualizar
    if (e.detail && e.detail.line && e.detail.quantity) {
      // Buscar el elemento cart-form
      const cartForm = document.querySelector('cart-form');
      if (cartForm && typeof cartForm.updateCartQty === 'function') {
        // Buscar el elemento del carrito
        const cartItem = document.querySelector(`[data-js-cart-item][data-line="${e.detail.line}"]`);
        if (cartItem) {
          // Actualizar la cantidad en el carrito
          cartForm.updateCartQty(cartItem, e.detail.quantity);
        }
      }
    }
  });
}

if (typeof ProductPage !== 'function') {
  // ... (El resto de tu código de ProductPage permanece igual)
}

if (typeof ProductVariants !== 'function') {
  // ... (El resto de tu código de ProductVariants permanece igual)
}